import { render, staticRenderFns } from "./PrecioCategoriaForm.vue?vue&type=template&id=1de2aab6&"
import script from "./PrecioCategoriaForm.vue?vue&type=script&lang=js&"
export * from "./PrecioCategoriaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports